import React from 'react'

const DropdownItem = (props) => {
    console.count("DropdownItem RUNNING");
    return (
        <div
            className={props.item.disabled ? `${props.className} ${props.disabledClassName}` : props.className}
            onClick={() => !props.item.disabled && props.onClick(props.item.title)}
            title={props.item.disabled ? props.item.disabledReason : undefined}
        >
            <img alt={"image"} className={props.img} src={props.item.image} />
            <button style={{ border: 0 }} disabled={props.item.disabled}>
                <h2>{props.item.title}</h2>
            </button>
        </div >
    )
}

export default DropdownItem